import classes from './confirm-modal.module.scss';

export const ConfirmModal = ({ confirmText }: any) => {
  return <div className={classes.message}>{confirmText}</div>;
};